import{m}from"./chunk-HBP5N4FR.js";m();import t from"platform";function p(){var o,i,r,n;return((i=(o=t)==null?void 0:o.os)==null?void 0:i.family)==="iOS"||((n=(r=t)==null?void 0:r.os)==null?void 0:n.family)==="Android"}export{p as a};
//# sourceMappingURL=chunk-TXAITGIS.js.map
